import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submit", "error", "errorMessage"]
    static values = {
        requiredTypes: Array
    }
    connect() {
        console.log('Simple Import Wizard connected', this.requiredTypesValue)
        this.files = new Map()
        this.updateSubmitButton()
    }

    handleFileValidation(event) {
        const { type, file } = event.detail
        console.log('File validated:', type, file)
        this.files.set(type, file)
        console.log('Files map:', Array.from(this.files.entries()))
        this.updateSubmitButton()
    }

    handleFileRemoval(event) {
        const { type } = event.detail
        this.files.delete(type)
        this.updateSubmitButton()
    }

    updateSubmitButton() {
        console.log('updateSubmitButton called')
        console.log('requiredTypesValue:', this.requiredTypesValue)
        console.log('files:', Array.from(this.files.entries()))

        const allFilesPresent = this.requiredTypesValue.every(type =>
            this.files.has(type)
        )

        console.log('allFilesPresent:', allFilesPresent)

        this.submitTarget.disabled = !allFilesPresent
        this.submitTarget.classList.toggle('is-disabled', !allFilesPresent)
    }

    submitFiles(event) {

        //disable the submit button
        this.submitTarget.disabled = true
        
        // Hide any previous errors
        this.hideError()

        event.preventDefault()

        const formData = new FormData()
        this.files.forEach((file, type) => {
            formData.append(`files[${type}]`, file)
        })

        fetch(this.submitTarget.dataset.submitUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
            },
            redirect: 'follow' // Follow redirects automatically
        })
            .then(response => {
                if (this.submitTarget.dataset.submitUrl.includes('simple-importer')) {
                    // Check if response was redirected (status 200 after following redirect)
                    if (response.ok || response.redirected) {
                        // Success - redirect to summary page
                        window.location.href = '/simple-importer/summary'
                    } else {
                        // Error response - try to parse JSON error
                        const contentType = response.headers.get('content-type') || ''
                        if (contentType.includes('application/json')) {
                            return response.json().then(data => {
                                throw new Error(data.message || data.error || 'Upload failed')
                            })
                        } else {
                            // Try to get text error
                            return response.text().then(text => {
                                throw new Error(text || 'Upload failed with status ' + response.status)
                            })
                        }
                    }
                } else {
                    return response.text().then(html => {
                        window.location.href = '/data-importer'
                    })
                }
            })
            .catch(error => {
                // re-enable the submit button
                this.submitTarget.disabled = false
                console.error('Upload failed:', error)
                
                // Show error to user
                const errorMessage = error.message || 'An error occurred while uploading the file. Please try again or contact support.'
                this.showError(errorMessage)
            })
    }
    
    showError(message) {
        if (this.hasErrorTarget && this.hasErrorMessageTarget) {
            this.errorMessageTarget.textContent = message
            this.errorTarget.classList.remove('u-hidden')
        }
    }
    
    hideError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.add('u-hidden')
            if (this.hasErrorMessageTarget) {
                this.errorMessageTarget.textContent = ''
            }
        }
    }
}